<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import type { FilterSections, FilterSortOption } from '../../types';
	import { setFilter } from '../../utils/setFilter/setFilter';
	import type { FilterTypesClasses } from '../FilterTypes/FilterTypes.svelte';
	import { FilterButton } from './FilterButton';
	import { FilterSorts } from './FilterSorts';
	import { page } from '$app/state';

	let {
		filterSections,
		sorts = undefined,
		withMaxSectionHeight = true,
		compact = false,
		scrollTarget = undefined,
		classes = {},
		pageParams = [],
		trackPrefix = undefined,
		...rest
	}: Props = $props();

	interface Props {
		class?: string;
		filterSections: FilterSections;
		sorts?: FilterSortOption[][] | undefined;
		withMaxSectionHeight?: boolean;
		compact?: boolean;
		scrollTarget?: string;
		pageParams?: string[];
		trackPrefix?: string;
		classes?: {
			filterButton?: string;
			filterButtonClasses?: FilterTypesClasses;
		};
	}

	$effect(() => {
		setFilter({
			filterSections,
			searchParams: page.url.searchParams,
			pageParams,
			trackPrefix
		});
	});
</script>

<div
	class={twMerge(
		compact
			? 'flex flex-row items-center justify-end gap-2 sm:gap-4'
			: 'flex flex-col justify-end gap-4 sm:flex-row',
		rest.class
	)}
>
	{#if !!sorts}
		<FilterSorts
			{sorts}
			{scrollTarget}
			class={compact ? 'min-w-0 flex-1 flex-row gap-2 sm:flex-none' : undefined}
		/>
	{/if}

	{#if !!filterSections?.length}
		<FilterButton
			{filterSections}
			{withMaxSectionHeight}
			{scrollTarget}
			containerClass={compact ? 'min-w-0 flex-1 sm:flex-none' : undefined}
			class={classes.filterButton}
			classes={classes.filterButtonClasses}
			{pageParams}
			{trackPrefix}
		/>
	{/if}
</div>
